import dash_api from '../../support/dash_api';
import { ReduxAsyncAction } from '../../support/utils';
import NotificationActions from '../NotificationActions';
import { ErrorProvider } from '../../../../libraries/branch-tooling-next/Error/ErrorProvider';

const errorProvider = new ErrorProvider();

const AASAUrl = new ReduxAsyncAction('AASA_URL');
AASAUrl.registerRequest(function (domain, $3p) {
  return dash_api
    .post('/v1/3p-onboarding/aasa', { domain, $3p })
    .then(({ data }) => data && data.data)
    .catch((error) => {
      NotificationActions.showNotification(errorProvider.parse(error).getResponse()?.data?.msg, 'error');
    });
});
export const getAASAUrl = AASAUrl.request;
export const AASA_URL = AASAUrl.constants;

const EspScript = new ReduxAsyncAction('ESP_SCRIPT', ['set', 'reset']);
EspScript.registerRequest(function ($3p) {
  return dash_api.post(`/v1/3p-onboarding/script`, { $3p }).then(({ data }) => data);
});
export const getEspScript = EspScript.request;
export const ESP_SCRIPT = EspScript.constants;
